<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-card outlined class="card">
            <v-card-title>
                SMTP Setup
                <v-icon class="setting-scope-icon">mdi-account-group</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="card-body">
                <v-form ref="smtpConfigForm" :lazy-validation="true" v-model="formValid">
                    <v-row>
                        <v-col cols="12" sm="3" md="3" lg="2">
                            <v-select label="Protocol" v-model="smtpConfig.protocol" color="#c42111" :items="protocolList" @change="protocolChange" />
                        </v-col>
                        <v-col cols="12" sm="5" md="4" lg="3">
                            <v-text-field autocomplete="off" label="Address" color="#c42111" v-model="smtpConfig.ipaddr" :rules="[validation.required(smtpConfig.ipaddr, 'Address'), validation.noSpaces(smtpConfig.ipaddr)]" />
                        </v-col>
                        <v-col cols="12" sm="3" md="2" lg="1">
                            <v-text-field autocomplete="off" label="Port" color="#c42111" v-model="smtpConfig.port" :rules="[validation.required(smtpConfig.port, 'Port'), validation.port(smtpConfig.port)]" />
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-text-field autocomplete="off" label="Username" color="#c42111" v-model="smtpConfig.username" :rules="[validation.noSpaces(smtpConfig.username)]" />
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <v-text-field autocomplete="off" label="Password" type="password" color="#c42111" v-model="smtpConfig.password" :rules="[validation.match(smtpConfig.password, smtpConfig.passwordVerify)]" />
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <v-text-field autocomplete="off" label="Password Verify" type="password" color="#c42111" v-model="smtpConfig.passwordVerify" :rules="[validation.match(smtpConfig.password, smtpConfig.passwordVerify)]" />
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-text-field autocomplete="off" label="Email From" color="#c42111" v-model="smtpConfig.data.smtp_from" :rules="[]" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn text @click="saveSmtpConfig" :disabled="lockSave">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-container>
</template>

<script>

export default {
    name: 'Smtp',
    props: [],
    components: {
    },
    data: () => ({
        formValid: true,
        smtpLoaded: false,
        lockSave: false,
        smtpConfig: {
            section: 'smtp',
            protocol: 'smtp',
            ipaddr: '',
            port: '',
            username: '',
            password: '',
            passwordVerify: '',
            data: {}
        },
        protocolList: [
            'smtp',
            'smtp/ssl',
            'smtp+starttls',
        ],
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            requiredIfAuth: (value, fieldName, authRequired) => ((value || value === 0 || !authRequired) ? true : false) || `${fieldName} is required`,
            email: (value, apply) => ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(value) || !apply) || "Invalid email address"),
            match: (value, valueToMatch) => (value === valueToMatch) || `Password doesn't match`,
            noSpaces: (value) => (!(/\s/.test(value)) || 'Cannot contain spaces'),
            port: (value) => (/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(value) || 'Invalid port'),
        },

    }),

    computed: {
        authRequired: function() {
            return (this.smtpConfig.protocol == 'smtp/ssl' || this.smtpConfig.protocol == 'smtp+starttls');
        }
    },

    methods: {
        getSmtpConfig: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "settings/smtp");
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.smtpConfig = result;
                this.smtpConfig.ipaddr = this.smtpConfig.address;
                //this.smtpConfig.passwordVerify = this.smtpConfig.password;
                this.$set(this.smtpConfig, 'passwordVerify', this.smtpConfig.password);
                this.smtpConfig.section = this.smtpConfig.device;
                TELSA.loading(false);
            });
        },

        saveSmtpConfig: function() {
            if(this.$refs.smtpConfigForm.validate()) {
                TELSA.loading(true);
                let route = (TELSA.apiHost + "settings/smtp");
                return this.$http.post(route, {args: {smtpConfig: this.smtpConfig}}).then(response => {
                    let result = response.body;
                    this.$store.commit('setIsDirty', false);
                    TELSA.loading(false);
                });
            }
        },

        protocolChange: function() {
            if(this.smtpConfig.protocol == 'smtp') {
                this.smtpConfig.password = '';
                this.smtpConfig.passwordVerify = '';
                this.smtpConfig.port = 25;
            }
            else if(this.smtpConfig.protocol == 'smtp/ssl') {
                this.smtpConfig.port = 465;
            }
            else if(this.smtpConfig.protocol == 'smtp+starttls') {
                this.smtpConfig.port = 587;
            }
        }

    },

    watch: {
        smtpConfig: {
            handler(newVal, oldVal) {
                if(this.smtpLoaded && !this.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
                else {
                    this.smtpLoaded = true;
                }
            },
            deep: true
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/device-passwords');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_smtp`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getSmtpConfig().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `SMTP configuration is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
            });
        });
    }
};
</script>

<style scoped>

</style>
